import React, { Suspense } from "react";
import { useApolloClient } from "@apollo/client";
import { USER_DATA } from "features/common/queries";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import { gql } from "@apollo/client";
import PropTypes from "prop-types";
import { env } from "utils/env";
import InvalidUser from "components/layout/InvalidUser";
import { LinearProgress, MuiThemeProvider } from "@material-ui/core";
import { defaultThemeCode, getMuiTheme } from "utils/themes";

const USER_DATA_QUERY = gql`
  query userData {
    userData {
      id
      isInternalUser
      countryId
      showAmountsWithVAT
      isExchangeRateFunctionality
      allowIndividualSearch
      allowAutomatedDecision
      showQuestionsInVCP
      showDecisionReasons
      dealerDrivenConsent
      customerDrivenConsent
      requestAlwaysConsent
      allowSoleTraderSearch
      allowInsurance
      allowSelectionInsuranceConvention
      useDownloadProductInStep4
      user
      admin
      dAdmin
      vAdmin
      estimator
    }
  }
`;

const ValidateUserProvider = ({ children }) => {
  const client = useApolloClient();

  const isAuthDisabled = env.REACT_APP_USE_CIAM?.toLowerCase() === "true";
  const { data, loading } = useQueryWithErrorHandling(USER_DATA_QUERY, { skip: !isAuthDisabled });

  if (!isAuthDisabled) return <>{children}</>;
  if (loading) return <></>;
  if (!data?.userData)
    return (
      <MuiThemeProvider theme={getMuiTheme(defaultThemeCode)}>
        <Suspense fallback={<LinearProgress />}>
          <InvalidUser />
        </Suspense>
      </MuiThemeProvider>
    );

  client.writeQuery({
    query: USER_DATA,
    data: { userData: data.userData },
  });

  return <>{children}</>;
};

ValidateUserProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ValidateUserProvider;
